angular.module('bmsApp.zone')
	.factory('ZoneSvc', [
		'$q',
		'$rootScope',
		'CRUDSvc',
		function ($q,
				  $rootScope,
				  CRUDSvc) {

			return {
				index: function (params) {
					return CRUDSvc.get('api/zones/index', params);
				},
				save: function (params) {
					return CRUDSvc.post('api/zones/save', params);
				}
			};

		}
	]);
